export interface AvailabilityTime {
  hour?: number;
  minute?: number;
  second?: number;
  nano?: number;
}

export class Availability {
  year?: number[];
  month?: number[];
  day?: number[];
  weekday?: number[] | string[];
  from?: AvailabilityTime | any;
  to?: AvailabilityTime | any;

  constructor(
    year?: number[],
    month?: number[],
    day?: number[],
    weekday?: number[],
    from?: AvailabilityTime,
    to?: AvailabilityTime,
  ) {
    this.year = year;
    this.month = month;
    this.day = day;
    this.weekday = weekday;
    this.from = from;
    this.to = to;
  }

  setFrom(hour: string) {
    this.from = this.parseHourToTimeArray(hour);
  }

  setTo(hour: string) {
    this.to = this.parseHourToTimeArray(hour);
  }

  parseHourToTimeArray(hour: string) {
    const parts = hour.split(':');
    return {
      hour: parseInt(parts[0]),
      minute: parseInt(parts[1]),
      second: null,
      nano: null,
    };
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
